import React from 'react';
import WebLayout from '../layouts/WebLayout';

const DownloadPage = () => {
    // TODO: 실제 앱스토어 및 구글 플레이 링크로 교체해주세요.
    const APP_STORE_URL = "https://apps.apple.com";
    const GOOGLE_PLAY_URL = "https://play.google.com";

    return (
        <WebLayout>
            <div className="min-h-screen bg-white">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                    {/* 메인 타이틀 */}
                    <div className="text-center mb-20">
                        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                            지금 바로 <span className="text-amber-500">밥친구</span> 시작하기
                        </h1>
                        <p className="text-xl text-gray-600">
                            새로운 사람들과 맛있는 식사를 함께 나누세요
                        </p>
                    </div>

                    {/* 다운로드 버튼들 */}
                    <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-20">
                        {/* App Store Button */}
                        <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className="block w-56 transition-transform hover:scale-105">
                            <div className="aspect-[4/1] rounded-lg overflow-hidden shadow-md">
                                <img
                                    src="/images/appstore.png"
                                    alt="app store"
                                    className="h-full w-full object-cover"
                                />
                            </div>
                        </a>

                        {/* Google Play Button */}
                        <a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer" className="block w-56 transition-transform hover:scale-105">
                            <div className="aspect-[4/1] rounded-lg overflow-hidden shadow-md">
                                <img
                                    src="/images/GetItOnGooglePlay_Badge_Web_color_Korean.png"
                                    alt="google play"
                                    className="h-full w-full object-cover"
                                />
                            </div>
                        </a>
                    </div>

                </div>
            </div>
        </WebLayout>
    );
};

export default DownloadPage;
